<template>
  <div class="news-card-box">
    <!-- 日期卡片 -->
    <div class="date-card">
      <div>{{ dateInfo[2] }}</div>
      <div>{{ dateInfo[0] }}&nbsp;{{ dateInfo[1] }}</div>
    </div>
    <div class="news-container">
      <!-- 标题 -->
      <div class="news-title">
        <span @click="handleClick">{{ news.newsTitle }}</span>
        <span>{{ news.newsCreateTime.substring(0, 10) }}</span>
      </div>
      <!-- 简介 -->
      <div class="news-intro">{{ news.newsSubcontent }}<a @click="handleClick">&nbsp;[详情]&nbsp;</a></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewsCard",
  props: {
    news: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dateInfo: []
    }
  },
  watch: {
    news: {
      immediate: true,
      handler(newVal) {
        if(newVal) {
          newVal.newsSubcontent = newVal.newsSubcontent && newVal.newsSubcontent.length > 80 
            ? newVal.newsSubcontent.substring(0, 80) + "..."
            : newVal.newsSubcontent ? newVal.newsSubcontent : ""
          if(newVal.newsSubcontent === newVal.newsTitle) {
            newVal.newsSubcontent = ""
          }
        }
        if(newVal?.newsCreateTime) {
          this.dateInfo = newVal.newsCreateTime.substring(0, 10).split("-")
        } else {
          this.dateInfo = []
        }
      },
    }
  },
  methods: {
    handleClick() {
      this.$router.push({
        path: `/index/info/${this.news.id}`,
        query: {
          linkMenuId: this.news?.newsMenuId || ""
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.news-card-box {
  height: 80px;
  display: flex;
  margin-top: 20px;
  background: #f2f2f2;
  .date-card {
    width: 80px;
    height: 100%;
    color: #FFFFFF;
    text-align: center;
    background-image: url("../assets/images/news-libg.jpg");
    > div:first-child {
      font-size: 30px;
      height: 50px;
      line-height: 60px;
    }
    > div:last-child {
      font-size: 14px;
    }
  }
  .news-container {
    flex: 1;
    padding: 0 20px;
    overflow: hidden;
    .news-title {
      line-height: 30px;
      display: flex;
      > span {
        white-space: nowrap;
      }
      > span:first-child {
        cursor: pointer;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 14px;
        color: #555555;
        font-weight: bold;
        &:hover {
          color: #fdc202;
        }
      }
      > span:last-child {
        text-align: right;
        width: 30%;
        float: right;
        font-size: 12px;
        color: #999999;
      }
    }
    .news-intro {
      a {
        cursor: pointer;
        text-decoration: none;
        font-size: 12px;
        color: #fdc202;
      }
      a:hover {
        text-decoration: underline
      }
    }
  }
}
</style>